<template>
  <div class="map-content" v-show='showSelf'>
    <div id="map"></div>
    <!-- <div id='mapHeader'>
            <el-button type="text">标准地图</el-button>
            <el-button type="text">卫星地图</el-button>
            <img class='mapZoom' src='/static/bimroad/imgs/FullScreen.png' />
        </div> -->
    <div class="toolbar">
      <el-button-group>
        <!-- <el-button icon="el-icon-zoom-in" size="mini">放大</el-button>
                <el-button icon="el-icon-zoom-out" size="mini">缩小</el-button> -->
        <el-button icon="iconfont icon-dingwei" size="mini" @click="getGeolocation">定位</el-button>
        <el-button icon="iconfont icon-qiehuan" size="mini" @click='switchMap'>切换</el-button>
        <el-button icon="iconfont icon-biaoji2" size="mini" @click="markcase = true">标记</el-button>
      </el-button-group>
      <!-- 测量 -->
      <el-dropdown trigger="click" @command="handleCommandMeasure">
        <el-button size="mini" icon="iconfont icon-juli1">
          测量<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="LineString"><i class="iconfont icon-juli" style="margin-right:5px;"></i>距离</el-dropdown-item>
          <el-dropdown-item command="Polygon"><i class="iconfont icon-mianji" style="margin-right:5px;"></i>面积</el-dropdown-item>
          <el-dropdown-item command="None"><i class="iconfont icon-quxiao1" style="margin-right:5px;"></i>取消</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 绘制 -->
      <el-dropdown trigger="click" @command="handleCommandDraw">
        <el-button size="mini" icon="iconfont icon-huizhi">
          标绘<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="Point"><i class="iconfont icon-dian" style="margin-right:5px;"></i>点</el-dropdown-item>
          <el-dropdown-item command="LineString"><i class="iconfont icon-xian" style="margin-right:5px;"></i>线</el-dropdown-item>
          <el-dropdown-item command="Polygon"><i class="iconfont icon-duobianxing" style="margin-right:5px;"></i>面</el-dropdown-item>
          <el-dropdown-item command="Rectangular"><i class="iconfont icon-juxing" style="margin-right:5px;"></i>矩形</el-dropdown-item>
          <el-dropdown-item command="Circle"><i class="iconfont icon-yuan" style="margin-right:5px;"></i>圆</el-dropdown-item>
          <el-dropdown-item command="None"><i class="iconfont icon-quxiao1" style="margin-right:5px;"></i>取消</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div id="popup"></div>
  </div>
</template>
<script>
import coordtransform from '../../assets/js/coordtransform';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { defaults as defaultControls, ScaleLine } from 'ol/control.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { XYZ, Vector as VectorSource } from 'ol/source.js';
import { getArea, getLength } from 'ol/sphere.js';
import { LineString, Polygon, Point } from 'ol/geom.js';
import { unByKey } from 'ol/Observable.js';
import Overlay from 'ol/Overlay.js';
import { transform, fromLonLat } from 'ol/proj.js';
import Draw, { createBox } from 'ol/interaction/Draw.js';
import { Circle as CircleStyle, Fill, Stroke, Style, Icon, Text } from 'ol/style.js';
import Feature from 'ol/Feature.js';
import { RoadVector } from '@/js/RoadVector.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import Geolocation from 'ol/Geolocation.js';
export default {
  name: 'mapView',
  data() {
    return {
      showSelf: true,
      mapobj: null,
      mapView: null,
      center: coordtransform.gcj02towgs84(113.6549139, 30.92351779),
      raster: null,
      annotation: null,
      source: null,
      vector: null,
      scaleLineControl: null,
      geometryType: 'Point',
      geometryFunction: null,
      draw: null,
      drawcase: false,
      // -- measure --
      measureDraw: null,
      measurecase: false,
      measureVector: null,
      measureSource: null,
      measureType: 'Length',
      output: 0,
      measureTooltipElement: null,
      measureTooltip: null,
      measureTooltipCoord: [],
      measureListener: null,
      measureSketch: null,
      // -- measure --
      // marker
      markcase: false,
      markerVector: null,
      markerSource: null,
      // 
      featureOverlay: null,
      highlight: null,
      //
      geolocation: null,

      featurePosition: [{
          name: '标注点1',
          point: [114.4095557928, 30.4546114542]
        },
        {
          name: '标注点2',
          point: [114.4095075130, 30.4531640393]
        },
        {
          name: '标注点3',
          point: [114.4096094370, 30.4505558636]
        }

      ],
      sosVector:null,//在地图上展示sos状态的工人
      sosSource:null,
    }
  },
  created() {

    this.mapView = new View({
      center: this.center,
      zoom: 14,
      maxZoom: 18
    })

    this.rasterUrl = new XYZ({
      title: "高德路网",
      url: "http://webrd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}"
    });

    this.satelliteImageLayerUrl = new XYZ({
      title: "谷歌卫星",
      url: "http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
    });

    this.raster = new TileLayer({
      source: this.rasterUrl
    });


    this.source = new VectorSource({ wrapX: false });
    this.measureSource = new VectorSource({ wrapX: false });
    this.vector = new VectorLayer({
      source: this.source,
    });
    this.measureVector = new VectorLayer({
      source: this.measureSource,
      style: new Style({
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new Stroke({
          color: '#ffcc33',
          width: 2
        }),
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color: '#ffcc33'
          })
        })
      })
    });

    this.sosSource = new VectorSource({wrapX: false});
    this.sosVector = new VectorLayer({
         source:this.sosSource,
         zIndex:40
    });

    this.scaleLineControl = new ScaleLine();
    this.scaleLineControl.setUnits('metric');
  },
  mounted() {
    //var that = this
    this.mapInit()
    //this.featureInit()
    $('.toolbar').hide();
  },
  methods: {
    resetMap() {
      this.mapobj.updateSize();
    },
    showSos(arr){
       arr.forEach((item,index)=>{
           if(item.convLng){
              item.convLon=item.convLng;
           }
           let point= new Point(this.fixBias(item.convLon,item.convLat));
           this.markerSos(point,item)
       })
    },
    markerSos(point,info){
       var feature=new Feature({
             geometry:point,
             iconType:'point',
             info:info
        })
        var style=new Style({
            image: new Icon(({
                src: '/static/bimroad/imgs/marker_sos.png',
                anchor: [0.5, 1],              //锚点
                // anchorOrigin:'top-right',       //锚点源
                // anchorXUnits: 'fraction',       //锚点X值单位
                // anchorYUnits: 'pixels',         //锚点Y值单位
                // offsetOrigin: 'top-right',      //偏移原点
                opacity: 1,
            })),
            // text: new Text({
            //     textAlign: 'center',            //位置
            //     textBaseline: 'bottom',         //基准线
            //     font: 'normal 16px 微软雅黑',    //文字样式
            //     text:"1",        //文本内容
            //     offsetY:-10,
            //     fill: new Fill({       //文本填充样式（即文字颜色)
            //         color: '#fff'
            //     }),
            //     // stroke: new Stroke({
            //     //     color: '#F00', 
            //     //     width: 2
            //     // })
            // }), 
        })
        feature.setStyle(style);
        this.sosSource.clear();
        this.sosSource.addFeature(feature);
    },
    addMarker: function(stake) {
      this.curstake = stake; 
      this.mapobj.getView().setCenter(this.fixBias(this.curstake.gisData.convLon, this.curstake.gisData.convLat));
      var currentPoint = new Point(this.fixBias(this.curstake.gisData.convLon, this.curstake.gisData.convLat));

      if (this.currentMarker == undefined){
          this.currentMarker = new Feature({
          type: 'geoMarker',
          geometry: currentPoint
        });
        var style = new Style({
          image: new Icon(({
            crossOrigin: 'anonymous',
            anchor: [0.5, 1],
            // scale:0.5, //标注图标大小                   
            src: '/static/bimroad/imgs/marker_model.png'
          }))
        });
        this.currentMarker.setStyle(style);
        this.markerSource.clear();
        this.markerSource.addFeature(this.currentMarker);
      }
      else{
        this.currentMarker.setGeometry(currentPoint);
      }
      
    },
    markRoad: function(roadData) {
      var roadLine = null;
      var that = this;
      roadData.gisLocs.map(item => {
        var point = that.fixBias(item.convLon, item.convLat);
        if (roadLine == null) {
          roadLine = new LineString([point]);
        } else {
          roadLine.appendCoordinate(point);
        }
        point.stake = item.stationVal;
      });
      var linefeatures = new Array();
      var feature = new Feature({
        type:'roadLine',
        geometry: roadLine,
      });
      feature.setStyle(function styleFunction(feature) {
        var styles = [];

        styles.push(
          new Style({
            stroke: new Stroke({
              color: '#09c48e',
              width: 10
            })
          })
        );

        // var geometry = feature.get("geometry");
        // geometry.forEachSegment(function(start, end) {
        //   var dx = end[0] - start[0];
        //   var dy = end[1] - start[1];
        //   var rotation = Math.atan2(dy, dx);
        //   // arrows
        //   styles.push(new Style({
        //     geometry: new Point(end),
        //     image: new Icon({
        //       src: '../data/arrow.png',
        //       anchor: [0.75, 0.5],
        //       rotateWithView: false,
        //       rotation: -rotation
        //     })
        //   }));
        // });

        return styles;
      });
      linefeatures.push(feature);
      //linefeatures.push(feature2);

      var roadLineSource = new VectorSource({
        features: linefeatures
      });
      this.mapobj.addLayer(new VectorLayer({
        source: roadLineSource,
      }));

      var curStakeData = roadData.gisLocs[0];
      var stake = {gisData:{convLon: curStakeData.convLon, convLat: curStakeData.convLat}};

      this.markerSource = new VectorSource({
        wrapX: false
      });
      var markerVector = new VectorLayer({
        source: this.markerSource,
        zIndex:45
      });
      this.mapobj.addLayer(markerVector);
      this.addMarker(stake);
     


    },
    mapInit() {
      this.mapobj = new Map({
        controls: defaultControls().extend([
          this.scaleLineControl
        ]),
        layers: [this.raster, this.vector, this.measureVector],
        target: 'map',
        loadTilesWhileAnimating: true,
        view: this.mapView
      });
      //var roadVector = new RoadVector();
      //roadVector.loadAllRoadVectors(this.mapobj);

      // ----选择道路时用的feature------
      this.featureOverlay = new VectorLayer({
        source: new VectorSource(),
        map: this.mapobj,
        style: new Style({
          stroke: new Stroke({
            color: '#f00',
            width: 2
          }),
          fill: new Fill({
            color: 'rgba(255,0,0,0.1)'
          })
        })
      });
      // ---------

      // 矢量标注的数据源
      // this.markerSource = new VectorSource({
      //     features: []
      // });
      // 矢量标注图层
      // this.markerVector = new VectorLayer({
      //     source: this.markerSource
      // });
      // this.mapobj.addLayer(this.markerVector);

      // 初始化点击和滑动事件
      this.mapobj.addLayer(this.sosVector);
      this.mapEventInit();
      // this.raster.setSource(this.rasterUrl);
      this.raster.setSource(this.satelliteImageLayerUrl);
    },
    mapEventInit() {
      var that = this;
      this.mapobj.on('pointermove', function(e) {
        if (that.drawcase || that.measurecase) {
          return
        }
        if (e.dragging) {
          //that.removeOverlay('marker-wrapper');
          return;
        }
        var pixel = that.mapobj.getEventPixel(e.originalEvent);
        var hit = that.mapobj.hasFeatureAtPixel(pixel);
        if (that.mapobj.getTargetElement()) {
          that.mapobj.getTargetElement().style.cursor = hit ? 'pointer' : '';
        }

      });

      this.mapobj.on('click', function(evt) {
        if (that.drawcase || that.measurecase) {
          return
        }
        var feature = that.mapobj.forEachFeatureAtPixel(evt.pixel, function(feature) {
          return feature;
        });
        if (feature) {
          var coordinate = evt.coordinate;
          //TODO:找到该坐标对应的桩号，指示web3d上跳转到该桩号

          // 点击的是公路feature
          if (feature.getProperties().NAME && feature.getProperties().PYNAME) {
            that.displayFeatureInfo(evt.pixel);
          }
          that.markcase = false;
          that.removeOverlay('marker-wrapper');
          var coordinates = feature.getGeometry().getCoordinates();
          if (coordinates.length == 2 && !(coordinates[0] instanceof Array)) {

            //目前人物相关的地图图标只有sos人员的，点击图标3D视角飞到sos人员那里
            var info = feature.get('info');
            if(info){
                 that.$parent.apiManager.drawApi.searchModel(info);
            }
            // that.addPopup(feature, coordinates);
          }
          var type = feature.get('type');
          if(type&&type=='roadLine'){
              var lonlat = that.fixBiasBack(coordinate[0],coordinate[1]);
              that.$parent.mapTo3d(lonlat);
          }
        } else {
          that.removeOverlay('marker-wrapper');
          if (that.markcase) {
            // var feature = that.addMarkFun(evt.coordinate, '我的标记')
            // that.addPopup(feature, evt.coordinate);
          }
        }
        //}

      });
    },
    featureInit() {
      if (this.featurePosition.length !== 0) {
        this.featurePosition.forEach((item) => {
          var coord = coordtransform.gcj02towgs84(item.point[0], item.point[1]);
          this.addMarkFun(coord, item.name);
        })
      }
    },
    handleCommandDraw(command) {
      this.drawcase = true;
      this.geometryType = command;
      if (command == 'Rectangular') {
        this.geometryType = 'Circle'
        this.geometryFunction = createBox();
      } else {
        this.geometryFunction = null
      }
      // 移除上次的draw
      this.mapobj.removeInteraction(this.draw);
      this.mapobj.removeInteraction(this.measureDraw);
      this.addDrawInteraction();
    },
    addDrawInteraction() {
      var that = this
      if (this.geometryType !== 'None') {
        this.draw = new Draw({
          source: this.source,
          type: this.geometryType,
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.5)'
            }),
            stroke: new Stroke({
              color: '#ffcc33',
              width: 2
            }),
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.6)'
              })
            })
          }),
          geometryFunction: this.geometryFunction
        });

        this.draw.on('drawend', function(evt) {
          var feature = evt.feature;
          var geometry = feature.getGeometry();
          var extent = geometry.getExtent();
          var features = that.markerVector.getSource().getFeaturesInExtent(extent); //先缩小feature的范围
          var coordinate, radius
          if (that.geometryType == 'Circle' && !that.geometryFunction) {
            coordinate = geometry.getCenter();
            radius = geometry.getRadius()
            for (var i = 0; i < features.length; i++) {
              var newCoords = features[i].getGeometry().getCoordinates();
              if (that.pointInsideCircle(newCoords, coordinate, radius)) {
                console.log('我在范围内: ' + features[i].get("name"))
              }
            }
          } else {
            coordinate = geometry.getCoordinates();
            for (var i = 0; i < features.length; i++) {
              var newCoords = features[i].getGeometry().getCoordinates();
              //if(that.insidePolygon(coordinate,newCoords)){
              console.log('我在范围内: ' + features[i].get("name"))
              //}
            }
          }
        })


        this.mapobj.addInteraction(this.draw);
      } else {
        this.drawcase = false;
      }
    },
    handleCommandMeasure(command) {
      //测距模式
      this.measurecase = true
      this.measureType = command
      // 移除上次的draw
      this.mapobj.removeInteraction(this.measureDraw);
      this.mapobj.removeInteraction(this.draw);
      this.addMeasureInteraction();
    },
    addMeasureInteraction() {
      var that = this
      if (this.measureType !== 'None') {
        this.measureDraw = new Draw({
          source: this.measureSource,
          type: this.measureType,
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)'
            }),
            stroke: new Stroke({
              color: 'rgba(0, 0, 0, 0.5)',
              lineDash: [10, 10],
              width: 2
            }),
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({
                color: '#ffcc33'
              })
            })
          }),
        });

        this.createMeasureTooltip();

        this.measureDraw.on('drawstart', function(e) {
          that.measureSketch = e.feature;
          that.measureTooltipCoord = e.coordinate;
          that.measureListener = that.measureSketch.getGeometry().on('change', function(evt) {
            var geom = evt.target;
            //debugger
            if (geom instanceof Polygon) {
              that.output = that.formatArea(geom);
              that.measureTooltipCoord = geom.getInteriorPoint().getCoordinates();
            } else if (geom instanceof LineString) {
              that.output = that.formatLength(geom);
              that.measureTooltipCoord = geom.getLastCoordinate();
            }
            that.measureTooltipElement.innerHTML = that.output;
            that.measureTooltip.setPosition(that.measureTooltipCoord);
          });
        }, this)

        this.measureDraw.on('drawend', function(e) {
          that.measureTooltipElement.className = 'tooltip tooltip-static';
          that.measureTooltip.setOffset([0, -7]);
          that.measureSketch = null;
          that.measureTooltipElement = null;
          that.createMeasureTooltip();
          that.creatCloseMeasure(that.measureTooltipCoord, e.feature);
          that.measureTooltipCoord = []
          unByKey(that.measureListener);
        }, this);

        this.mapobj.addInteraction(this.measureDraw);
      } else {
        this.measurecase = false;
      }
    },
    switchMap() {
      if (this.raster.getSource() == this.satelliteImageLayerUrl) {
        this.raster.setSource(this.rasterUrl);
      } else {
        this.raster.setSource(this.satelliteImageLayerUrl);
      }
    },
    formatLength(line) {
      var length = getLength(line);
      var output;
      if (length > 100) {
        output = (Math.round(length / 1000 * 100) / 100) +
          ' ' + 'km';
      } else {
        output = (Math.round(length * 100) / 100) +
          ' ' + 'm';
      }
      return output;
    },
    formatArea(polygon) {
      var area = getArea(polygon);
      var output;
      if (area > 10000) {
        output = (Math.round(area / 1000000 * 100) / 100) +
          ' ' + 'km<sup>2</sup>';
      } else {
        output = (Math.round(area * 100) / 100) +
          ' ' + 'm<sup>2</sup>';
      }
      return output;
    },
    createMeasureTooltip() {
      if (this.measureTooltipElement) {
        this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
      }
      this.measureTooltipElement = document.createElement('div');
      this.measureTooltipElement.className = 'tooltip tooltip-measure';
      this.measureTooltip = new Overlay({
        element: this.measureTooltipElement,
        offset: [0, -15],
        positioning: 'bottom-center',
        ///className: 'measuretooltip'
      });
      this.mapobj.addOverlay(this.measureTooltip);
    },
    creatCloseMeasure(coordinate = [], feature) {
      var that = this;
      var closeMeasureEle = document.createElement('div');
      closeMeasureEle.className = 'measure-close';
      closeMeasureEle.innerHTML = 'X';
      var featureCoordinate = feature.getGeometry().getLastCoordinate();
      closeMeasureEle.setAttribute('data-coordinate', coordinate.join(','));
      closeMeasureEle.setAttribute('data-featureCoordinate', featureCoordinate.join(','));
      var closeMeasure = new Overlay({
        element: closeMeasureEle,
        offset: [15, 20],
        positioning: 'bottom-left',
      });
      closeMeasure.setPosition(coordinate);
      this.mapobj.addOverlay(closeMeasure);
      $('.measure-close').unbind().bind('click', function() {
        var coord = $(this).attr('data-coordinate').split(',');
        var featurecoord = $(this).attr('data-featureCoordinate').split(',');
        var overlayArr = that.getOverLayFromCoord(coord);
        var features = that.measureVector.getSource().getFeatures();
        that.measureSource.removeFeature(that.getFeatureFromCoord(features, featurecoord));
        for (var i = 0; i < overlayArr.length; i++) {
          that.mapobj.removeOverlay(overlayArr[i]);
        }

      })
    },
    addMarkFun(coordinate, name) {
      //新建一个要素ol.Feature
      var newFeature = new Feature({
        geometry: new Point(coordinate), //几何信息
        name: name
      });
      //设置要素样式
      newFeature.setStyle(this.createMarkStyle(newFeature));
      this.markerSource.addFeature(newFeature);

      // 添加标记的名称
      var markerTipEle = document.createElement('div');
      markerTipEle.className = 'tooltip tooltip-marker';
      markerTipEle.innerHTML = name;
      var markerTip = new Overlay({
        element: markerTipEle,
        offset: [10, 0],
        positioning: 'bottom-left',
        ///className: 'measuretooltip'
      });
      this.mapobj.addOverlay(markerTip);
      markerTip.setPosition(coordinate);
      return newFeature;
    },
    addPopup(feature, coordinate) {

      // if (feature && feature.get('name') !== undefined && feature.get('note') !== undefined) {
      //   var note = feature.get('note')
      //   var str = '<div class="content-text">' + note + '</div>'
      //   this.addPopupFun(feature, str, coordinate);
      // } else {
      //   this.addFormPopup(feature, coordinate);
      // }
    },
    addFormPopup(feature, coordinate) {
      var str = '<div class="marker-name clearfix"><span>名称</span><input type="text" placeholder="我的标记" /></div>' +
        '<div class="marker-note clearfix"><span>备注</span><textarea placeholder="我的备注"></textarea></div>'
      this.addPopupFun(feature, str, coordinate);
    },
    // popup
    addPopupFun(feature, content, coordinate) {
      var that = this,
        btn, titleName
      if (feature && feature.get('name') !== undefined && feature.get('note') !== undefined) {
        btn = '<input class="marker-edit" type="button" value="编辑"/>'
        titleName = feature.get('name')
      } else {
        btn = '<input class="marker-save" type="button" value="保存"/>'
        titleName = '添加标注'
      }
      var str = '<div class="marker-wrapper">' +
        '<div class="marker-title">' + titleName + '</div>' +
        '<div class="marker-content clearfix">' +
        content +
        '<div class="marker-footer">' + btn + '<input class="marker-del" type="button" value="删除"/></div>' +
        '</div>' +
        '<div class="marker-arrow"></div>' +
        '<span class="marker-close">X</span>' +
        '</div>'
      $('#popup').append(str)
      $('.marker-close').on('click', this.closePopup)
      $('.marker-wrapper').on('click', '.marker-save', function() {
        that.markerSave(feature)
      })
      $('.marker-wrapper').on('click', '.marker-edit', function() {
        that.markerEdit(feature)
      })
      $('.marker-wrapper').on('click', '.marker-del', function() {
        that.markerDel(feature)
      })

      //实例化overlay标注，添加到地图容器中
      var newOverlay = new Overlay({
        //position: coordinate,
        positioning: 'bottom-center',
        element: $('.marker-wrapper')[0],
        stopEvent: true,
        offset: [0, -25],
      });
      this.mapobj.addOverlay(newOverlay);
      newOverlay.setPosition(coordinate);
      // 添加完之后就退出标记模式
      if (this.markcase) this.markcase = false;
    },
    closePopup(event) {
      this.removeOverlay('marker-wrapper');
    },
    markerSave(feature) {
      var name = $('.marker-wrapper').find('input[type=text]').val() || '我的标记'
      var note = $('.marker-wrapper').find('textarea').val() || '我的备注'
      feature.setProperties({
        name: name,
        note: note
      })
      this.removeOverlay('marker-wrapper');
      var coordinate = feature.getGeometry().getCoordinates();
      var overlay = this.getOverLayFromCoord(coordinate);
      overlay[0].getElement().innerHTML = name;
    },
    markerEdit(feature) {
      var name = feature.get('name');
      var note = feature.get('note') || '';
      var str = '<div class="marker-name clearfix"><span>名称</span><input type="text" placeholder="我的标记" value="' + name + '" /></div>' +
        '<div class="marker-note clearfix"><span>备注</span><textarea placeholder="我的备注">' + note + '</textarea></div>' +
        '<div class="marker-footer"><input class="marker-save" type="button" value="保存"/><input class="marker-del" type="button" value="删除"/></div>'
      $('.marker-content').empty().append(str)
    },
    markerDel(feature) {
      this.markerSource.removeFeature(feature);
      this.removeOverlay('marker-wrapper');
      this.removeOverlay('tooltip-marker');
    },
    removeOverlay(arg) {
      if (arg === undefined) {
        return
      }
      if (arg === true) {
        this.mapobj.getOverlays().clear();
      }
      if (typeof arg == 'string') {
        var that = this
        var overlayers = this.mapobj.getOverlays();
        overlayers.forEach(function(item) {
          if (item && item.getElement().className.indexOf(arg) >= 0) {
            that.mapobj.removeOverlay(item);
          }
        })
      }

    },
    // 矢量标注样式设置函数，设置image为图标ol.style.Icon
    createMarkStyle(feature) {
      console.log(feature);
      return new Style({
        image: new Icon(({
          anchor: [0.5, 25], //锚点
          anchorOrigin: 'top-right', //锚点源
          anchorXUnits: 'fraction', //锚点X值单位
          anchorYUnits: 'pixels', //锚点Y值单位
          offsetOrigin: 'top-right', //偏移原点
          opacity: 0.75,
          src: '../../static/bimroad/img/marker_red.png' //图标的URL
        })),
        // text: new Text({
        //     textAlign: 'center',            //位置
        //     textBaseline: 'middle',         //基准线
        //     font: 'normal 16px 微软雅黑',    //文字样式
        //     text:  feature.get('name'),        //文本内容
        //     fill: new Fill({       //文本填充样式（即文字颜色)
        //         color: '#000'
        //     }),
        //     stroke: new Stroke({
        //         color: '#F00', 
        //         width: 2
        //     })
        // }),
      });
    },
    displayFeatureInfo(pixel) {
      var feature = this.mapobj.forEachFeatureAtPixel(pixel, function(feature) {
        return feature;
      });
      if (feature !== this.highlight) {
        if (this.highlight) {
          this.featureOverlay.getSource().removeFeature(this.highlight);
        }
        if (feature) {
          this.featureOverlay.getSource().addFeature(feature);
          alert(feature.get('NAME'))
        }
        this.highlight = feature;
      }
    },
    // 根据坐标获取对应的overlay
    getOverLayFromCoord(coordinate) {
      var overlayers = this.mapobj.getOverlays().array_;
      var arr = [];
      var overlay = overlayers.forEach((item) => {
        if (item.getPosition() && item.getPosition()[0] == coordinate[0] && item.getPosition()[1] == coordinate[1]) {
          arr.push(item);
        }
      })
      return arr;
    },
    getFeatureFromCoord(features, coordinate) {
      var feature = features.find((item) => {
        var point = item.getGeometry().getLastCoordinate();
        return (point[0] == coordinate[0] && point[1] == coordinate[1]);
      })
      return feature;
    },
    getGeolocation() {
      var that = this
      this.geolocation = new Geolocation({
        // enableHighAccuracy must be set to true to have the heading value.
        trackingOptions: {
          enableHighAccuracy: true
        },
        projection: that.mapView.getProjection()
      });
      console.log(this.geolocation.getPosition())

      var coord = coordtransform.gcj02towgs84(114.4075495005, 30.4533443893) //[114.4095182419,30.4531131713]
      console.log('114.4075495005,30.4533443893   : ', coord)
      this.mapView.animate({
        center: coord,
        duration: 1000
      });

      this.addMarkFun(coord, '我的标记');

    },
    fixBias(lon, lat){
      return transform(coordtransform.wgs84togcj02(lon, lat), 'EPSG:4326', 'EPSG:3857');
    },
    fixBiasBack(lon,lat){
      var data = transform([lon,lat],'EPSG:3857','EPSG:4326');
      return coordtransform.gcj02towgs84(data[0],data[1]);
    },
    /**
     *  判断一个点是否在多边形内部
     *  @param points 多边形坐标集合
     *  @param testPoint 测试点坐标
     *  返回true为真，false为假
     **/
    insidePolygon(points, testPoint) {
      var x = testPoint[0],
        y = testPoint[1];
      var inside = false;
      for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
        var xi = points[i][0],
          yi = points[i][1];
        var xj = points[j][0],
          yj = points[j][1];

        var intersect = ((yi > y) != (yj > y)) &&
          (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
      }
      return inside;
    },
    /**
     *  判断一个点是否在圆的内部
     *  @param point  测试点坐标
     *  @param circle 圆心坐标
     *  @param r 圆半径
     *  返回true为真，false为假
     **/
    pointInsideCircle(point, circle, r) {
      if (r === 0) return false
      var dx = circle[0] - point[0]
      var dy = circle[1] - point[1]
      return dx * dx + dy * dy <= r * r
    }
  }
}

</script>
<style lang="less">
@import '../../assets/css/themeColor';
@import '../../assets/css/ol.css';
.map-content {
  width: 100%;
  height: 100%;
  position: relative;
  .ol-zoom{
     display:none;
  }
  #map {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  /*#mapHeader{
            position:absolute;
            height:60px;
            width:100%;
            top:2px;
            button{
                float:left;
                font-weight:bold;
                font-size:16px;
                margin:10px 0 0 20px;
                color:#227AE4;
            }
            .mapZoom{
                float:right;
                height:23px;
                width:23px;
                margin:16px 15px 0 0;
                
            }
        }*/
  .toolbar {
    position: absolute;
    top: 10px;
    left: 5%;
    z-index: 999;
    font-size: 0;

    .el-button-group>.el-button:last-child {
      border-right: none;
      border-radius: 0;
    }

    .el-button-group {
      .iconfont {
        font-size: 12px;
        margin-right: 2px;
      }
    }

    .el-dropdown {
      vertical-align: middle;

      &:not(:last-child) {
        .el-button--mini {
          border-radius: 0;
          border-right: none;
        }
      }

      &:last-child {
        .el-button--mini {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }

      .iconfont {
        font-size: 12px;
        margin-right: 2px;
      }
    }
  }

  .tooltip {
    position: relative;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    color: white;
    padding: 4px 8px;
    opacity: 0.7;
    white-space: nowrap;
  }

  .tooltip-measure {
    opacity: 1;
    font-weight: bold;
  }

  .measure-close {
    display: inline-block;
    background: #fff;
    font-size: 12px;
    line-height: 1;
    color: red;
    border: 1px solid red;
    cursor: pointer;
  }

  .tooltip-static {
    background-color: #ffcc33;
    color: black;
    border: 1px solid white;
  }

  .tooltip-measure:before,
  .tooltip-static:before {
    border-top: 6px solid rgba(0, 0, 0, 0.5);
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    content: "";
    position: absolute;
    bottom: -6px;
    margin-left: -7px;
    left: 50%;
  }

  .tooltip-static:before {
    border-top-color: #ffcc33;
  }

  #marker {
    width: 20px;
    height: 20px;
    border: 1px solid #088;
    border-radius: 10px;
    background-color: #0FF;
    opacity: 0.5;
  }

  .marker-wrapper {
    background: #fff;
    width: 300px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    color: #606266;
    line-height: 1.4;
    min-width: 150px;
    border: 1px solid #ebeef5;
    text-align: justify;
    //padding: 20px;
    font-size: 14px;
    margin-bottom: 12px;
    border-radius: 4px;
    position: relative;
    z-index: 10;

    .marker-title {
      padding: 0 15px;
      line-height: 30px;
      background: rgb(249, 249, 249);
      border-bottom: 1px solid #ccc;
      padding: 0 15px;
    }

    .marker-content {
      padding: 5px 15px;

      //padding-top: 5px;
      .marker-name,
      .marker-note {
        span {
          float: left;
          margin-right: 5px;
        }

        input {
          color: rgb(140, 140, 140);
          float: left;
          width: 200px;
          height: 15px;
          padding: 3px;
          font-size: 12px;
          line-height: 18px;
          border: 1px solid rgb(181, 181, 181);
        }

        textarea {
          border: #b5b5b5 solid 1px;
          color: #8C8C8C;
          float: left;
          font-size: 12px;
          line-height: 1.5;
          height: 64px;
          overflow-y: auto;
          padding: 3px;
          width: 200px;
        }
      }

      .marker-note {
        margin-top: 5px;
      }
    }

    .marker-footer {
      margin: 10px 0;
      float: right;

      input {
        margin-right: 5px;
      }
    }

    .marker-arrow {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      bottom: -6px;
      left: 50%;
      margin-right: 3px;
      border-top-color: #ebeef5;
      border-bottom-width: 0;

      &:after {
        content: " ";
        border-width: 6px;
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        bottom: 1px;
        margin-left: -6px;
        border-top-color: #fff;
        border-bottom-width: 0;
      }
    }

    .marker-close {
      position: absolute;
      top: 5px;
      right: 20px;
      font-size: 14px;
      color: rgb(204, 204, 204);
      cursor: pointer;

      &:hover {
        color: #606266;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/plugins/page/main/map.vue